'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { isLandingVariantPath } from '@/src/shared/landing/landingVariant';

const BackgroundOverlay = dynamic(() => import('./BackgroundOverlay'), {
  ssr: false,
});

const isElectronBuild = process.env.NEXT_PUBLIC_ELECTRON === 'true';

/**
 * Keeps the application/Electron background behavior while leaving the public
 * homepage's own full-screen background as the only active background there.
 * The prerendered landing variants render under /landing-variant/* but hydrate
 * at "/", so both count as the homepage (otherwise hydration mismatches).
 */
export default function RuntimeBackgroundOverlay() {
  const pathname = usePathname();

  if (!isElectronBuild && (pathname === '/' || isLandingVariantPath(pathname))) {
    return null;
  }

  return <BackgroundOverlay />;
}
